import { Card, CardContent } from "@/components/uiDir/card";

interface WelcomeBannerProps {
  name: string;
}

export const WelcomeBanner = ({ name }: WelcomeBannerProps) => {
  return (
    <Card className="border-0 shadow-lg bg-primary text-white overflow-hidden">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl text-white font-bold mb-2">
              Welcome back, {name.split(' ')[0]}! 
            </h2>
            <p className="text-white/90">Ready to showcase your latest work?</p>
          </div>
          <img className="h-16 w-16 opacity-70 [filter:grayscale(1)_brightness(3)_invert(0.1)]" src="/INNEWGEN.png" alt="logo" />
        </div>
      </CardContent>
    </Card>
  );
};